import {
    general as textsGeneral,
    shoppingCart as textsShoppingCart,
    paymentMethods as textsPaymentMethods,
    address as textsAddress
} from '../../../translate/Translate.jsx'

import './order.scss'

const Order = ({order}) => {
    return <div className={'order'}>
        <div className={'items'}>
            <label className={'title'}>
                {textsGeneral.items}
            </label>
            {order.itens.map((item, index) => <div key={index} className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {`${item.quantidade}x ${item.titulo}`}
                    </label>
                    <label className={'label'}>
                        {(item?.preco || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
                <>
                    {item.subItens.map((subitem, index) => <div key={index} className={'div-content-item'}>
                        <div className={'item'}>
                            <label className={'label'}>
                                {`${subitem.quantidade}x ${subitem.titulo}`}
                            </label>
                            {(subitem.preco !== 0) && <label className={'label'}>
                                {(subitem?.preco || 0).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                })}
                            </label>}
                        </div>
                    </div>)}
                </>
            </div>)}
        </div>
        <div className={'items'}>
            <label className={'title'}>
                {textsGeneral.information}
            </label>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsGeneral.name}
                    </label>
                    <label className={'label'}>
                        {order.cliente_nome}
                    </label>
                </div>
            </div>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsGeneral.phone}
                    </label>
                    <label className={'label'}>
                        {order?.cliente_telefone || ''}
                    </label>
                </div>
            </div>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        N°
                    </label>
                    <label className={'label'}>
                        {`#${order?.id_pedido.slice(-4)}`}
                    </label>
                </div>
            </div>
        </div>
        <div className={'items'}>
            <label className={'title'}>
                {textsGeneral.status}
            </label>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {`(${order.retorno.status}) - ${order?.retorno?.message || ''}`}
                    </label>
                </div>
            </div>
        </div>
    </div>
}

export default Order
